export const blockIconsHouseholdRoofingNew = (
	<span className='material-symbols-outlined'>roofing</span>
);
